// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#modal-api-loading___BV_modal_outer_ .modal{background-color:hsla(0,0%,80%,.2);backdrop-filter:blur(4px);cursor:progress}#modal-api-loading___BV_modal_outer_ .modal-content{background-color:transparent;-webkit-box-shadow:none;box-shadow:none}", ""]);
// Exports
module.exports = exports;
